<template>
  <Breadcrumb v-show="visible" class="sl-breadcrumb" separator="/">
    <BreadcrumbItem v-for="(item,index) in paths" :to="item.path" :key="'p'+index">
      <Icon class="ic" :custom="item.icon" v-if="item.icon"></Icon>{{item.title}}
    </BreadcrumbItem>
    <!-- <div v-if="enableBack" class='sl-breadcrumb-footer'>
      <a @click="onBack()">返回上一级</a>
    </div> -->
  </Breadcrumb>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    paths: {
      type: Array
    },
    enableBack: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    visible() {
      return this.paths.length > 0
    }
  },
  methods: {

    onBack(flag) {
      if (flag === true) {

      } else {
        this.$router.back(-1)
      }

    }
  }
}

</script>
